import { CUSTOM_QTY_UNITS_ATTR_ID } from 'es6/constants'
import { ItemPageableCollection } from 'es6/components/item-pageable-collection'
import { cartDiscountSum } from 'init/cart-discount-sum'
import { cartSum } from 'init/cart-sum'
import { okoPush } from 'helpers/oko-helpers'
import { fractionNumber } from 'helpers/number-helpers'
import { Collection } from 'es6/components/collection'
import { CartDiscountMixin } from 'es6/mixins/cart-discount-mixin'
import { Item } from 'es6/models/item'
import { CartItem } from 'es6/models/cart-item'
import { Discounts } from 'es6/collections/discounts'
import { cartQty } from 'init/cart-qty'
import { currentCurrency } from 'init/current-currency'
import { entryScriptName } from 'init/entry-script-name'
import { minSumOrder } from 'init/min-sum-order'
import { fastDeliverySum } from 'init/fast-delivery-sum'
import { isMobile } from 'init/is-mobile'

import $ from 'init/jquery'
import Backbone from 'init/backbone'
import each from 'lodash/each'
import extend from 'lodash/extend'
import clone from 'lodash/clone'
import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'
import isArray from 'lodash/isArray'
import isNumber from 'lodash/isNumber'
import isUndefined from 'lodash/isUndefined'
import map from 'lodash/map'
import omit from 'lodash/omit'
import some from 'lodash/some'
import { Defaults } from 'es-decorators'

/**
 * Коллекция для корзины
 */
@Defaults({
  expand: 'item,wish_item,gifts_discount',

  model: CartItem,

  settlementId: null,

  url: `${entryScriptName}/api/v3/cart-item/`,

  mode: 'infinite',

  sortTypes: ['-created', '-date', 'price', '-price', 'price-unit', '-price-unit', 'name', 'sid', 'discount'],

  requestFilters: false,

  viewTypes: ['list'],

  hasRestrictions: 0,

  isOnlyPositiveQty: null,

  // Минимальная сумма заказа
  minOrderSum: parseFloat(minSumOrder),
  minOrderSumRur: 0,
  isExclusion: 0,

  deliveryExtraPrice: 0,
  deliveryExtraMessage: '',

  isScroll: false,

  // подарки
  gifts: [],
  // группы (удаленный склад, сима-ленд)
  groups: [],
  // если синхронизируется с рр
  isSyncing: false,
  itemsNotAvailableInLoan: false,
  discounts: false,
  discountSum: 0,
  discountComplete: {},
  // Товары, обновления количества которых ждем
  awaitedItems: {},
  ADD_BY_ARTICUL_MAX_QTY: 1000,
  // минимальное количество символов в артикуле для определения где артикул, а где количество товара
  SYMBOLS_IN_ARTICLE: 6,

  defaults: {
    pageSize: 20,
    sort: '-created',
    mode: 'infinite',
    viewtype: 'cards',
  },

  state: {
    firstPage: 1,
    pageSize: 20,
    order: 0,
  },

  /**
   * get-параметры для запроса к api (/cart-main/)
   */
  queryParams: {
    totalRecords: null,
    currentPage: 'page',
    pageSize: 'per-page',
    expand: function () {
      return `${this.expand},volume_discount,wholesale,gifts_discount,badges`
    },
    currency: () => currentCurrency.name,
    sort: function () {
      return this.sort
    },
    enable_wholesale_price: 1,
    has_restrictions: function () {
      return this.hasRestrictions
    },
    is_only_positive_qty: function () {
      return this.isOnlyPositiveQty
    },
    settlement_id: function () {
      return this.settlementId
    },
    light_item: 1,
  },
  additionalOptions: ['settlement', 'recommendationsEvents', 'giftsCollection'],
})
export class Cart extends ItemPageableCollection {
  /** @inheritDoc */
  initialize (models, options) {
    this.attachOptions(options)
    this.currencySign = currentCurrency.sign
    this.cartSummaryBlocks = null
    this.currency = currentCurrency
    this.cartInfo = {
      sum: cartSum,
      items_count: cartQty,
      units_count: 0,
      cart_discount: 0,
      sum_with_discount: 0,
      fast_delivery_sum: fastDeliverySum,
    }
    this.itemsNotAvailableInLoan = new Collection()
    this.discountSum = cartDiscountSum
    this.discounts = new Discounts()
    this.sort = '-created'

    // Пробрасываем в GTM события добавления в корзину товара
    this.listenTo(this,
      'add',
      model => {
        if (this.recommendationsEvents) {
          this.recommendationsEvents.trigger('itemInCart', model.get('item_sid'))
        }
        this.resetCart()
      }
    )
    this.listenTo(this, 'cart-item-refresh', this.cartItemRefresh)
    this.listenTo(Backbone, 'minSumUpdated', this.updateMinOrderSum)
    this.updateMinOrderSum(this.settlement)

    // привязываем обработчики к событиям конкретной коллекции
    this.listenTo(this, 'reset updateQty', this._triggerEventOnCartUpdated)
    this.listenTo(Backbone, 'change-currency', () => {
      if (!this.router) {
        this.setCurrency(currentCurrency.name)
        this.fetch()
      }
    })
    this.listenTo(Backbone, 'update-cart-info', data => {
      extend(this.cartInfo, data.cartInfo)
      this.trigger('cart-update')
    })
    this.listenTo(Backbone, 'update-paid-delivery', data => {
      this.deliveryExtraPrice = data.paidDelivery.sum
      this.deliveryExtraMessage = data.paidDelivery.message
    })
    this.listenTo(Backbone, 'update-discount', data => {
      this._parseDiscount(data.discount)
    })
    this.awaitedItems = {}
  }
  /**
   * Добавляет сиды к адресу запроса
   * @param {Array} sids
   */
  setUrlWithSids (sids) {
    if (sids.length) {
      if (isUndefined(this.queryParams.sids)) {
        this.queryParams.sids = ''
      }
      this.queryParams.sids += (this.queryParams.sids ? ',' : '') + sids.join(',')
    }
  }

  /**
   * Заполнение коллекции корзины моделями товаров.
   * @param {Object} resp
   * @param {Object} options
   * @returns {Object} Models
   */
  parseRecords (resp, options) {
    this.cartInfo = resp._cart
    this.totalPages = resp._meta.pageCount
    this.totalCount = resp._meta.totalCount
    this.costModifiers = resp._cost_modifiers
    this.deliveryExtraPrice = resp['_paid-delivery'].sum
    this.deliveryExtraMessage = resp['_paid-delivery'].message
    this.gifts = resp._gifts
    this.groups = resp._groups
    this._parseDiscount(this.getDiscountData(resp))
    if (resp.cart_summary_blocks) {
      this.updateCartSummaryBlocks(resp.cart_summary_blocks)
    }
    if (resp._items_not_available_in_loan) {
      this._parseItemsNotAvailableInLoan(resp._items_not_available_in_loan)
    }
    return map(resp.items, obj => {
      if (some(obj.item.attrs, { attr_id: CUSTOM_QTY_UNITS_ATTR_ID, boolean_value: 1 })
          && obj.item.nestedUnit && obj.item.in_set > 0 && obj.item.in_set !== 1
      ) {
        obj.item.has_custom_qty_units = true
      }
      // eslint-disable-next-line new-cap
      return new this.model(obj, options)
    })
  }

  /**
   * Заполнение коллекции товаров не доступных для покупки в кредит
   * @param {Array} itemsNotAvailableInLoanData
   * @private
   */
  _parseItemsNotAvailableInLoan (itemsNotAvailableInLoanData) {
    if (isArray(itemsNotAvailableInLoanData) && itemsNotAvailableInLoanData.length) {
      let result = []
      each(itemsNotAvailableInLoanData, itemNotAvailableInLoan => {
        let data = itemNotAvailableInLoan.cart_item
        data.item = new Item(itemNotAvailableInLoan.item)
        result.push(new CartItem(data))
      })
      this.itemsNotAvailableInLoan.reset(result)
    }
  }

  /**
   * Заполнение коллекции акций
   * @param {Object} discountData
   * @private
   */
  _parseDiscount (discountData) {
    this.trackDiscountCompleteness(discountData.discounts)
    this.discounts.reset(discountData.discounts)
    this.discountSum = discountData.sum
  }

  /**
   * Сохраняем состояние прогресса акций, чтобы перерисовывать при завершении.
   * @param {Object[]} discounts
   */
  trackDiscountCompleteness (discounts) {
    if (discounts) {
      discounts.forEach(discount => {
        if (!this.discountComplete.hasOwnProperty(discount.id)) {
          this.discountComplete[discount.id] = discount.isComplete
        }
        if (this.discountComplete[discount.id] !== discount.isComplete && this.fetchCounter >= 1) {
          this.discountComplete[discount.id] = discount.isComplete
          if (this.router && this.router.mode === 'infinite') {
            this.trigger('reset-cart')
            this.resetCart()
          } else {
            this.trigger('update-on-discount-complete')
          }
        }
      })
    } else {
      this.discountComplete = {}
    }
  }

  /**
   * Сбрасывание состояния коллекции и переход на первую страницу
   * @param {boolean} addedBySid
   */
  resetCart (addedBySid = false) {
    this.fullCollection.reset()
    if (this.router && !addedBySid) {
      this.getFirstPage({ remove: true })
    } else {
      this.getFirstPage({ fetch: true })
    }
  }

  /**
   * Обрабатывает значения общей стоимости
   * @param {Array} cartSummaryBlocks
   */
  updateCartSummaryBlocks (cartSummaryBlocks) {
    if (Array.isArray(cartSummaryBlocks)) {
      const updatedCartSummaryBlocks = cloneDeep(cartSummaryBlocks)
      updatedCartSummaryBlocks.map(function (line) {
        if (line.price && line.price.value) {
          line.price.value = fractionNumber(line.price.value)
          return line
        } else {
          return line
        }
      })
      this.cartSummaryBlocks = updatedCartSummaryBlocks
    }
  }

  /**
   * Минимальная сумма заказа
   * @returns {number} minOrderSum
   */
  getMinOrderSum () {
    return parseFloat(this.minOrderSum)
  }

  /**
   * Минимальная сумма заказа
   * @param {Item} model
   */
  updateMinOrderSum (model) {
    if (!model) {
      model = this.settlement
      if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
        Raven.captureException(new Error('TypeError: model is undefined when settlement is ' + this.settlement.get('name')))
      }
    }
    this.minOrderSum = parseFloat(model.get('min_order_sum'))
    this.minOrderSumRur = parseFloat(model.get('min_order_sum_rur'))
    this.isExclusion = model.get('is_exclusion')
    this.trigger('updatedMinSum')
  }

  /**
   * Проверяет больше ли текущая сумма минимальной.
   * @param {number} settlementMinSum Минимальная сумма, если нужно принудительно сравнить с ней
   * @returns {boolean} true, если больше
   */
  validateMinSum (settlementMinSum) {
    settlementMinSum = settlementMinSum || this.getMinOrderSum()
    return this.cartInfo.sum >= settlementMinSum || this.user.get('has_no_order_sum_restrictions')
  }

  /**
   * Проверяет, есть ли товары с удаленного склада
   * @returns {boolean} true если есть
   */
  checkRemoteItems () {
    if (!this.cartInfo.groups) {
      return false
    }
    let remoteGroup = find(this.cartInfo.groups, { code: 'remote' })
    return remoteGroup.sum > 0
  }

  /**
   * Возвращает объект с группами, если есть одновременно и товары с удаленного склада, и с локального
   * @returns {Object|null} объект с группами
   */
  getGroups () {
    if (!this.cartInfo.groups) {
      return null
    }
    const remoteItems = this.getGroupByName('remote')
    if (!(remoteItems && remoteItems.sum)) {
      return null
    }
    const localItems = this.getGroupByName('local')
    if (!(localItems && localItems.sum)) {
      return null
    }
    return {
      remote: remoteItems,
      local: localItems,
    }
  }

  /**
   * Возвращает объект с группой выбранного названия
   * @param {string} name Название группы
   * @returns {Object|null} объект с группой
   */
  getGroupByName (name) {
    let result
    if (this.cartInfo.groups) {
      result = find(this.cartInfo.groups, { code: name })
    }
    return result || null
  }

  /**
   * Добавление товаров по артикулу
   * @param {string} sids
   * @returns {Object} requestData
   */
  addByArticul (sids) {
    let artList = sids
        .replace(/[^\d\s,]|\s+/g, ' ') // Заменяет все символы, кроме запятых и одинарных пробелов на пробел
        .split(/[,\s+]/g) // Разделяет строку на массив по пробелу или запятой
        .filter(Boolean)
        .reduce((result, item, index, array) => {
          if (item.length >= this.SYMBOLS_IN_ARTICLE) {
            const nextItem = array[index + 1]
            const product = { item_sid: item }
            if (nextItem && nextItem.length < this.SYMBOLS_IN_ARTICLE) {
              product.qty = Number(nextItem)
            }
            result.push(product)
          }
          return result
        }, []),
      requestData
    if (artList.length > this.ADD_BY_ARTICUL_MAX_QTY) {
      artList = artList.slice(0, this.ADD_BY_ARTICUL_MAX_QTY)
    }
    requestData = { items: artList }
    $.ajax({
      url: `${entryScriptName}/api/v3/cart/main/?expand=items`,
      type: 'PUT',
      data: requestData,
      success: data => {
        // @todo при добавлении (только количества) пересчитывать сумму всей корзины.
        this.resetCart(true)
        // отправление данных о добавленных товарах в око
        for (let i of data.items) {
          if (sids.split(/[,\s]+/).indexOf('' + data.items[i].item_sid) >= 0) {
            okoPush({
              n: 'add-to-cart',
              sid: data.items[i].item_sid,
              q: data.items[i].qty,
            })
            // отправка события для добавления данных в DataLayer
            this.trigger('pushAddedByArticleToDataLayer', data.items[i])
          }
        }
        // событие успешного добавления в корзину по артикулу
        this.trigger('addedCartByArticle', data, artList)
      },
    })
    return requestData
  }

  /**
   * Смена валюты в корзине и конвертирование минимальных сумм для оформления заказа в выбранную валюту.
   */
  setCurrency () {
    ItemPageableCollection.prototype.setCurrency.apply(this, arguments)
    this.currency = currentCurrency

    // Минимальная и фактическая минимальная сумма заказы всегда одинаковы
    this.minOrderSum = parseFloat((this.minOrderSumRur / this.currency.rate).toFixed(2))
    this.trigger('currency-set')
  }

  /**
   * Обновление информации о доставке при удалении из корзины, либо при смене города.
   * @param {Object} deletedModel удаляемая модель.
   */
  cartItemRefresh (deletedModel) {
    let isInfinite = false
    if (!isMobile && this.router) {
      isInfinite = this.router.mode === 'infinite'
    }
    if (this.cartInfo.items_count > this.state.pageSize && !isInfinite) {
      Backbone.trigger('DeleteItemFromCart')
      return
    }

    let settlementIdUrlPart = this.settlementId ? `&settlementId=${this.settlementId}` : ''
    let request = `${entryScriptName}/api/v3/cart-item/?
    expand=item,volume_discount,gifts_discount,wholesale,3_price_2_discount,large_family&light_item=1&v=${Date.now()}${settlementIdUrlPart}`
    $.get(request, data => {
      this.updateAfterCartRefresh(data, deletedModel)
    })
  }

  /**
   * Обновление метаданных корзины после удаления товара из корзины или смены города
   * @param {Object} data
   * @param {Object} deletedModel
   */
  updateAfterCartRefresh (data, deletedModel) {
    this.deliveryExtraPrice = data['_paid-delivery'].sum
    this.deliveryExtraMessage = data['_paid-delivery'].message
    this._parseDiscount(this.getDiscountData(data))
    this.gifts = data._gifts
    if (this.giftsCollection) {
      this.giftsCollection.reset(this.gifts)
    }
    if (data.cart_summary_blocks) {
      this.updateCartSummaryBlocks(data.cart_summary_blocks)
    }
    if (data._cart) {
      this.cartInfo = data._cart
      Backbone.trigger('update-cart-info', { cartInfo: data._cart })
    }
    // Обновляем информацию о времени доставки у товара только при смене города.
    if (deletedModel) {
      Backbone.trigger('DeleteItemFromCart')
    } else {
      this.trigger('delivery-info-change')
    }
  }

  /**
   * Очищает корзину
   */
  clear () {
    this.reset()
    this.trigger('clear')

    $.ajax({
      url: `${entryScriptName}/api/v3/cart/main/`,
      type: 'DELETE',
    })
  }

  /**
   * Удаляет товары из корзины по списку их id.
   * @param {Array} ids Массив с id товаров, которые должны быть удалены из корзины.
   */
  deleteByItemsIds (ids) {
    if (ids && ids.length) {
      this.sync('delete', this, {
        url: `${entryScriptName}/api/v3/cart-item/${ids}/`,
        wait: true,
        method: 'DELETE',
        success: () => {
          // Штатное событие remove не срабатывает при множественном удалении, поэтому инициируем его искусственно.
          each(ids, id => {
            let model = this.findWhere({ id: id })
            if (model) {
              this.trigger('remove', model)
              Backbone.trigger('changeQtyForOko', 'remove', model.toJSON())
            }
          })
          this.remove(ids)
          this.trigger('removeCheckedFromCart')
          this.resetCart()
        },
      })
    }
  }

  /**
   * @inheritDoc
   */
  fetch (options = {}) {
    // Добавляем в опции запроса обработчик ошибки.
    let url

    options.error = (collection, response) => {
      if (response.status === 404 && this.router) {
        /*
         * Если в модели есть currentPage
         * (на случай удалениия последнего товара на странице)
         * перекидываем на предыдущую
         */
        if (this.state.currentPage > 1) {
          url = `/p${(this.state.currentPage - 1)}`
        } else {
          // Редирект на первую страницу корзины
          url = '/'
        }
        this.router.navigate(url, { trigger: true })
      }
    }
    let result = ItemPageableCollection.prototype.fetch.apply(this, arguments)
    if (this.queryParams.sids) {
      delete this.queryParams.sids
    }
    return result
  }

  /**
   * Переопределен для возможности перехвата ошибок.
   * @param {Object} resp
   * @param {Object} options
   * @returns {Array} модели товаров
   */
  parse (resp, options) {
    try {
      let newState = this.parseState(resp, clone(this.queryParams), clone(this.state), options),
        state = extend({}, this.state, newState)
      this.setLinks(state)
      if (newState) {
        this.state = this._checkState(state)
      }
      return this.parseRecords(resp, options)
    } catch (e) {
      this.trigger('page-range-error')
    }
    return this.parseRecords(resp, options)
  }

  /**
   * Устанавливает линки
   * @param {Object} state
   */
  setLinks (state = this.state) {
    if (this.mode === 'infinite') {
      let links = this.links = {},
        firstPage = state.firstPage,
        totalPages = Math.ceil(state.totalRecords / state.pageSize),
        lastPage = firstPage === 0 ? Math.max(0, totalPages - 1) : totalPages || firstPage
      for (let i = state.firstPage; i <= lastPage; i++) {
        links[i] = this.url
      }
    }
  }

  /**
   * Устанавливает количество моделей на странице. если передан pageSize
   * @param {number} pageSize
   * @param {Object} options
   * @param {number} page
   * @returns {*|XMLHttpRequest|Backbone.PageableCollection} количество моделей
   */
  setPageSize (pageSize, options = { first: false }, page) {
    if (!pageSize) {
      return this
    }

    let state = this.state,
      totalPages = Math.ceil(state.totalRecords / pageSize),
      currentPage = this.getCurrentPageByPageSize(pageSize)

    state = extend({}, state, {
      pageSize: pageSize,
      currentPage: options.first ? state.firstPage : currentPage,
      totalPages: totalPages,
    })

    this.setLinks(state)

    state = this.state = this._checkState(state)

    if (page !== this.state.currentPage && page >= 1
        && (page <= this.state.totalPages || this.state.totalPages === 0)
    ) {
      state = this.state = this._checkState(extend({}, state, {
        currentPage: page,
      }))
    }

    return this.getPage(state.currentPage, omit(options, ['first']))
  }

  /**
   * Сохранение ссылки на роутер в this.router
   * @param {Router} router
   */
  setRouter (router) {
    /*
     * todo доделать с переносом корзины на ES6.
     * if (router instanceof app.CartRouter) {
     *   this.router = router
     * }
     */
  }

  /**
   * Запросить все товары из корзины, для отправки в сервис кредитного брокера
   */
  getLoanCartItemData () {
    if (this.state.totalPages) {
      let result = [],
        currentPage = this.state.currentPage,
        totalPages = this.state.totalPages,
        collectData = model => {
          if (model.is_balanced) {
            result.push({
              id: model.item_id.toString(),
              price: model.price.toString(),
              count: model.qty.toString(),
              type: model.item.loan_category_name.toString(),
              name: model.item.name.toString(),
            })
          }
        }
      each(this.toJSON(), collectData)
      if (totalPages === 1) {
        this.trigger('sync-loan-data', result)
        return
      }
      for (let i = (currentPage + 1); i <= totalPages; i += 1) {
        this.getNextPage({
          remove: false,
          success: (collection, resp) => {
            if (resp.items && resp.items.length) {
              each(resp.items, collectData)
              if (result.length === collection.state.totalRecords) {
                this.trigger('sync-loan-data', result)
              }
            }
          },
        })
      }
    }
  }

  /**
   * Установка параметров для заказа с удаленного склада
   */
  setRemoteQueryParams () {
    this.queryParams.group = 'remote'
    this.queryParams.remote_order = 1
  }

  /**
   * Добавление айди товара к списку ожидаемых
   * @param {number} id
   */
  addItemIdToAwaited (id) {
    if (isNumber(id)) {
      this.awaitedItems[id] = true
    }
  }

  /**
   * Удалить айди товара из списка ожидаемых
   * Если корзина готова, триггерим событие
   * @param {number} id
   */
  removeItemIdFromAwaited (id) {
    if (isNumber(id)) {
      delete this.awaitedItems[id]
    }
    if (this.isCartItemsReady()) {
      this.trigger('cart:ready-for-validation')
    }
  }

  /**
   * Проверка готовности корзины.
   * @returns {boolean} true, если список ожидаемых товаров пуст
   */
  isCartItemsReady () {
    return Object.keys(this.awaitedItems).length === 0
  }

  /**
   * Вызывает события, когда в корзине что-то изменилось.
   * @private
   */
  _triggerEventOnCartUpdated () {
    // Не реагируем на события во время синхронизации с РР
    if (!this.isSyncing) {
      if (this.cartInfo.items_count === 0) {
        this.trigger('empty-cart')
      }
      Backbone.trigger('cqc:command', {
        type: 'cart/UPDATE',
        cart: {
          id: this.cartInfo.cart_id,
          total_items_count: this.cartInfo.items_count,
          positive_balance_cart_sum: this.cartInfo.sum,
          sum_with_discount: this.cartInfo.sum_with_discount,
        },
      })
      this.trigger('update')
    }
  }
}

extend(Cart.prototype, CartDiscountMixin)
